// extracted by mini-css-extract-plugin
var _1 = "TabScrollList-moduleTabScrollList__Aiqsf ScrollSlider-moduleScrollSliderContent__iqXiY";
var _2 = "TabScrollList-modulecontent__NYUOD";
var _3 = "TabScrollList-modulewrapper__zIrvw";
export { _1 as "TabScrollList", _2 as "content", _3 as "wrapper" }
